let initialState = {
    products: [
        {id: 1, img: "https://storage.googleapis.com/jawa-apps.appspot.com/product/5n_1629507833231.jpg"},
        {id: 2, img: "https://storage.googleapis.com/jawa-apps.appspot.com/product/6a_1629675541139.jpg"},
        {id: 3, img: "https://storage.googleapis.com/jawa-apps.appspot.com/product/77_1630362733942.jpeg"},
        {id: 4, img: "https://storage.googleapis.com/jawa-apps.appspot.com/product/6a_1629675541139.jpg"},
        {id: 5, img: "https://storage.googleapis.com/jawa-apps.appspot.com/product/5n_1629507833231.jpg"},
        {id: 6, img: "https://storage.googleapis.com/jawa-apps.appspot.com/product/77_1630362733942.jpeg"},
        {id: 7, img: "https://storage.googleapis.com/jawa-apps.appspot.com/product/5n_1629507833231.jpg"},
        {id: 8, img: "https://storage.googleapis.com/jawa-apps.appspot.com/product/77_1630362733942.jpeg"},
        {id: 9, img: "https://storage.googleapis.com/jawa-apps.appspot.com/product/6a_1629675541139.jpg"},
        {id: 10, img: "https://storage.googleapis.com/jawa-apps.appspot.com/product/5n_1629507833231.jpg"},
        {id: 11, img: "https://storage.googleapis.com/jawa-apps.appspot.com/product/6a_1629675541139.jpg"},
        {id: 12, img: "https://storage.googleapis.com/jawa-apps.appspot.com/product/77_1630362733942.jpeg"},
        {id: 13, img: "https://storage.googleapis.com/jawa-apps.appspot.com/product/5n_1629507833231.jpg"}
    ]
}

let storeReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_PRODUCTS':
			return {
				products: action.array,
				...state,
			}

		default:
			return state
	}
}

export const setProducts = (array) => ({ type: 'SET_PRODUCTS', array })

export default storeReducer
